export default __webpack_public_path__ + "static/media/computer-screen.35c75648.svg";